import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { FeatureFlagsConfig } from './feature-flags-config.model';
import { FeatureFlagsService } from './feature-flags.service';

export function provideFeatureFlags(config: FeatureFlagsConfig): EnvironmentProviders[] {
  return [
    provideAppInitializer(() => {
      const featureFlagsService = inject(FeatureFlagsService);

      return featureFlagsService.initialize(config);
    }),
  ];
}
